<template>
    <div>
        <CModal
                add-content-classes="bg-transparent border-0"
                :no-close-on-backdrop="true"
                :centered="true"
                :show.sync="openVerify"
                :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div class="closeBtnContainer" @click="loginModal=false">
                    <p class="closeButton">
                        <img src="@/assets/icons/closeButton.svg" style="background-color: white; border-radius: 50%;">
                    </p>
                </div>
            </template>
            <template #body-wrapper>
                    <CCol style="align-items: center" class="completeContainer">
                            <CRow class="title">
                                <label>CONFIRM VERIFY CODE</label>
                            </CRow>

                        <CRow class="completeButton" style="margin-top: 1rem">
                            <input placeholder="Enter your verify code" class="textInput"/>
                        </CRow>
                        <CRow class="text-danger" style="justify-content: flex-end;width: 96%;margin-bottom: 1rem">
                            <label style="border-bottom: 1px solid black; font-size: 0.75rem;color: black;font-style: italic;font-weight: bold">Didn't get one?</label>
                        </CRow>

                            <CRow class="completeButton">
                                <CButton color="success" style="border-radius: 24px;width: 40%">Submit</CButton>
                            </CRow>
                    </CCol>
            </template>
            <template #footer-wrapper>
                <div/>
            </template>
        </CModal>
    </div>
</template>

<script>
    export default {
        name: "complete",
        props:{
            openVerify:Boolean
        },
    }
</script>

<style scoped>
    .closeBtnContainer {
        padding-right: 1rem;
    }

    .closeButton {
        align-content: flex-end;
        float: right;
        width: 26px;
        height: 26px;
        padding-top: -100px;
        margin-right: 12px;
        cursor: pointer;
        margin-bottom: 0.1em;
    }

    .completeContainer {
        width: 80%;
        border-radius: 20px;
        background-color: white;
        padding-top: 1.75rem;
        padding-bottom: 1.75rem;
        align-self: center;
    }

    .title {
        color: black;
        justify-content: center;
        font-family: Roboto;
        margin-bottom: 0.7rem;
        font-size: 1.28rem;
    }

    .completeButton {
        justify-content: center;
    }


    .textInput{
        border:0px;
        border-bottom: 1px solid #ccc;
        width: 76%;
    }

</style>